// --- FILE: frontend/src/pages/admin/AdminTestingSettings.tsx ---
// ИСПРАВЛЕНО: api() → apiUrl(), добавлено объявление компонента
import { apiUrl } from '../../config/paths';
import React, { useEffect, useState } from 'react';
import { Box, Typography, Switch, FormControlLabel, Alert, Button } from '@mui/material';

export default function AdminTestingSettings() {
  const [enabled, setEnabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);

  const load = async () => {
    setErr(null);
    setOk(null);
    try {
      const r = await fetch(apiUrl('/admin/settings/testing/auto-confirm'));
      const d = await r.json();
      if (!r.ok) throw new Error(d?.message || 'Ошибка загрузки настройки');
      setEnabled(!!d.enabled);
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : String(e));
    }
  };

  const save = async () => {
    setLoading(true);
    setErr(null);
    setOk(null);
    try {
      const r = await fetch(apiUrl('/admin/settings/testing/auto-confirm'), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d?.message || 'Ошибка сохранения');
      setEnabled(!!d.enabled);
      setOk('Настройка сохранена.');
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', my: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Настройки «Тест ССТО»
      </Typography>
      <Typography sx={{ mb: 1 }}>
        Тумблер включает автоматическое подтверждение теста при строгом совпадении ID терминала
        (Inmarsat/Iridium) и попадании времени в окно заявки. MMSI/название — только подсказки
        оператору.
      </Typography>
      {err && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {err}
        </Alert>
      )}
      {ok && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {ok}
        </Alert>
      )}
      <FormControlLabel
        control={<Switch checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />}
        label="Автоподтверждение тестов по точному совпадению ID терминала"
      />
      <Box sx={{ mt: 2 }}>
        <Button variant="contained" disabled={loading} onClick={save}>
          Сохранить
        </Button>
      </Box>
    </Box>
  );
}
